import(/* webpackMode: "eager" */ "/src/src/app/[variants]/not-found.tsx");
